import { render, staticRenderFns } from "./PasiBsaPhase.vue?vue&type=template&id=1e8118ba&scoped=true&"
import script from "./PasiBsaPhase.vue?vue&type=script&lang=js&"
export * from "./PasiBsaPhase.vue?vue&type=script&lang=js&"
import style0 from "./PasiBsaPhase.vue?vue&type=style&index=0&id=1e8118ba&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e8118ba",
  null
  
)

export default component.exports